// @flow
export default class NotAServiceBubble extends Error {
  constructor() {
    super("Can't set service-bubble properties of non-service-bubble url block!");
  }
}
